module.exports = __webpack_public_path__ + "img/ico-info.ff85c656.svg";